import Immutable from "immutable";

const initialState = {
    participants: [],
    loadingParticipants: false,
    loadingParticipantsFailed: false,
    loadingParticipantsError: "",
    participantIndex: -1,
    participantId: 0,
    participantFirstName: "",
    participantFirstNameErrors: [],
    participantLastName: "",
    participantLastNameErrors: [],
    participantBirthDate: "",
    participantBirthDateErrors: [],
    participantGender: "MALE",
    participantGenderErrors: [],
    participantErrorsVisible: false,
    savingParticipant: false,
    savingParticipantFailed: false,
    savingParticipantError: "",
    deletingParticipant: false,
    deletingParticipantFailed: false,
    deletingParticipantError: ""
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "GET_PARTICIPANTS_PENDING":
            return Immutable
                .fromJS(state)
                .set("loadingParticipants", true)
                .set("loadingParticipantsFailed", false)
                .set("loadingParticipantsError", "")
                .toJS();
        case "GET_PARTICIPANTS_FULFILLED":
            return Immutable
                .fromJS(state)
                .set("participants", action.payload.data)
                .set("loadingParticipants", false)
                .toJS();
        case "GET_PARTICIPANTS_REJECTED":
            return Immutable
                .fromJS(state)
                .set("participants", [])
                .set("loadingParticipants", false)
                .set("loadingParticipantsFailed", true)
                .set("loadingParticipantsError", action.payload.response.data.message)
                .toJS();
        case "ADD_PARTICIPANT":
            return Immutable
                .fromJS(state)
                .update("participants", participants => participants.push({
                    id: action.participantId,
                    firstName: action.participantFirstName,
                    lastName: action.participantLastName,
                    birthDate: action.participantBirthDate,
                    gender: action.participantGender
                }))
                .set("participantIndex", state.participants.length)
                .set("participantId", action.participantId)
                .set("participantFirstName", action.participantFirstName)
                .set("participantFirstNameErrors", action.participantFirstNameErrors)
                .set("participantLastName", action.participantLastName)
                .set("participantLastNameErrors", action.participantLastNameErrors)
                .set("participantBirthDate", action.participantBirthDate)
                .set("participantBirthDateErrors", action.participantBirthDateErrors)
                .set("participantGender", action.participantGender)
                .set("participantGenderErrors", action.participantGenderErrors)
                .set("participantErrorsVisible", false)
                .toJS();
        case "EDIT_PARTICIPANT":
            return Immutable
                .fromJS(state)
                .set("participantIndex", action.participantIndex)
                .set("participantId", action.participantId)
                .set("participantFirstName", action.participantFirstName)
                .set("participantFirstNameErrors", action.participantFirstNameErrors)
                .set("participantLastName", action.participantLastName)
                .set("participantLastNameErrors", action.participantLastNameErrors)
                .set("participantBirthDate", action.participantBirthDate)
                .set("participantBirthDateErrors", action.participantBirthDateErrors)
                .set("participantGender", action.participantGender)
                .set("participantGenderErrors", action.participantGenderErrors)
                .set("participantErrorsVisible", false)
                .toJS();
        case "CANCEL_PARTICIPANT":
            var immutableState = Immutable.fromJS(state);
            if (state.participantId === 0) {
                immutableState = immutableState.set("participants", state.participants.filter((participant, index) => index !== state.participantIndex))
            }
            return immutableState
                .set("participantIndex", -1)
                .set("participantId", 0)
                .set("participantFirstName", "")
                .set("participantFirstNameErrors", [])
                .set("participantLastName", "")
                .set("participantLastNameErrors", [])
                .set("participantBirthDate", "")
                .set("participantBirthDateErrors", [])
                .set("participantGender", "MALE")
                .set("participantGenderErrors", [])
                .toJS();
        case "DISPLAY_PARTICIPANT_VALIDATION_ERRORS":
            return Immutable
                .fromJS(state)
                .set("participantErrorsVisible", true)
                .toJS();
        case "SAVE_PARTICIPANT_PENDING":
            return Immutable
                .fromJS(state)
                .set("savingParticipant", true)
                .set("savingParticipantFailed", false)
                .set("savingParticipantError", "")
                .toJS();
        case "SAVE_PARTICIPANT_FULFILLED":
            return Immutable
                .fromJS(state)
                .set("participants", state.participants.map((participant, index) => state.participantIndex === index ? action.payload.data : participant))
                .set("participantIndex", -1)
                .set("participantId", 0)
                .set("participantFirstName", "")
                .set("participantFirstNameErrors", [])
                .set("participantLastName", "")
                .set("participantLastNameErrors", [])
                .set("participantBirthDate", "")
                .set("participantBirthDateErrors", [])
                .set("participantGender", "MALE")
                .set("participantGenderErrors", [])
                .set("savingParticipant", false)
                .toJS();
        case "SAVE_PARTICIPANT_REJECTED":
            return Immutable
                .fromJS(state)
                .set("savingParticipant", false)
                .set("savingParticipantFailed", true)
                .set("savingParticipantError", action.payload.response.data.message)
                .toJS();
        case "DELETE_PARTICIPANT_PENDING":
            return Immutable
                .fromJS(state)
                .set("participantId", action.meta.participantId)
                .set("deletingParticipant", true)
                .set("deletingParticipantFailed", false)
                .set("deletingParticipantError", "")
                .toJS();
        case "DELETE_PARTICIPANT_FULFILLED":
            return Immutable
                .fromJS(state)
                .set("participants", state.participants.filter(participant => participant.id !== state.participantId))
                .set("participantId", 0)
                .set("deletingParticipant", false)
                .toJS();
        case "DELETE_PARTICIPANT_REJECTED":
            return Immutable
                .fromJS(state)
                .set("participantId", 0)
                .set("deletingParticipant", false)
                .set("deletingParticipantFailed", true)
                .set("deletingParticipantError", action.payload.response.data.message)
                .toJS();
        case "UPDATE_PARTICIPANT_FIRST_NAME":
            return Immutable
                .fromJS(state)
                .set("participantFirstName", action.value)
                .set("participantFirstNameErrors", action.errors)
                .toJS();
        case "UPDATE_PARTICIPANT_LAST_NAME":
            return Immutable
                .fromJS(state)
                .set("participantLastName", action.value)
                .set("participantLastNameErrors", action.errors)
                .toJS();
        case "UPDATE_PARTICIPANT_BIRTH_DATE":
            return Immutable
                .fromJS(state)
                .set("participantBirthDate", action.value)
                .set("participantBirthDateErrors", action.errors)
                .toJS();
        case "UPDATE_PARTICIPANT_GENDER":
            return Immutable
                .fromJS(state)
                .set("participantGender", action.value)
                .set("participantGenderErrors", action.errors)
                .toJS();
        case "CLEAR_ERRORS":
            return Immutable
                .fromJS(state)
                .set("loadingParticipantsFailed", false)
                .set("loadingParticipantsError", "")
                .set("savingParticipantFailed", false)
                .set("savingParticipantError", "")
                .set("deletingParticipantFailed", false)
                .set("deletingParticipantError", "")
                .toJS();
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/participants.js